/**
 * Utilitário para tratamento de erros do React Admin
 * Extrai mensagens específicas de diferentes estruturas de erro
 */

export interface ErrorResponse {
  body?: {
    message?: string
    error?: string
    details?: Array<{ message?: string }>
  }
  message?: string
}

export const extractErrorMessage = (
  error: ErrorResponse,
  defaultMessage = 'Erro inesperado'
): string => {
  // Tentar extrair mensagem de diferentes estruturas de erro
  if (error?.body?.message) {
    return error.body.message
  }

  if (error?.body?.error === 'code_conflict') {
    return ERROR_MESSAGES.COUPON_CODE_EXISTS
  }

  if (error?.body?.error === 'invalid_payload') {
    return error.body.message || ERROR_MESSAGES.INVALID_DATA
  }

  if (error?.body?.error === 'validation_error') {
    return error.body.message || ERROR_MESSAGES.VALIDATION_ERROR
  }

  if (error?.body?.error === 'not_found') {
    return ERROR_MESSAGES.NOT_FOUND
  }

  if (error?.body?.error === 'invalid_code') {
    return ERROR_MESSAGES.INVALID_CODE
  }

  if (
    error?.body?.error === 'unauthorized' ||
    error?.body?.error === 'forbidden'
  ) {
    return ERROR_MESSAGES.UNAUTHORIZED
  }

  if (error?.message) {
    // Verificar se é uma mensagem específica do backend
    if (error.message.includes('Código do cupom já existe')) {
      return 'Código do cupom já existe. Escolha outro código.'
    }

    if (error.message.includes('Erro interno ao criar cupom')) {
      return 'Erro interno do servidor. Tente novamente em alguns instantes.'
    }

    if (error.message.includes('já existe')) {
      return 'Este item já existe. Escolha outro identificador.'
    }

    if (error.message.includes('não encontrado')) {
      return 'Item não encontrado. Verifique se ainda existe.'
    }

    if (error.message.includes('Cupom não encontrado')) {
      return ERROR_MESSAGES.NOT_FOUND
    }

    if (error.message.includes('Código do cupom inválido')) {
      return ERROR_MESSAGES.INVALID_CODE
    }

    if (error.message.includes('Unauthorized')) {
      return ERROR_MESSAGES.UNAUTHORIZED
    }

    return error.message
  }

  if (error?.body?.details && Array.isArray(error.body.details)) {
    // Erro de validação Joi com detalhes
    const firstError = error.body.details[0]
    if (firstError?.message) {
      return firstError.message
    }
  }

  return defaultMessage
}

/**
 * Mensagens específicas para diferentes tipos de erro
 */
export const ERROR_MESSAGES = {
  COUPON_CODE_EXISTS: 'Código do cupom já existe. Escolha outro código.',
  INVALID_DATA: 'Dados inválidos. Verifique os campos obrigatórios.',
  VALIDATION_ERROR: 'Erro de validação. Verifique os dados inseridos.',
  SERVER_ERROR:
    'Erro interno do servidor. Tente novamente em alguns instantes.',
  NETWORK_ERROR: 'Erro de conexão. Verifique sua internet e tente novamente.',
  UNAUTHORIZED: 'Você não tem permissão para realizar esta ação.',
  NOT_FOUND: 'Item não encontrado. Verifique se ainda existe.',
  DELETE_ERROR: 'Erro ao arquivar cupom. Tente novamente.',
  INVALID_CODE: 'Código do cupom inválido.',
} as const
